<template>
    <div class="learning-library" data-test-view="learning-library-paths">
        <l-headline :title="$t(`learning.library.paths.title`)" :tabs="tabs"></l-headline>

        <l-grid :list="selfenrolList" :cols="3">
            <template #item="{ item }">
                <div class="card" data-test-id="learning-library-paths-enrollable-card">
                    <div class="card-block">
                        <div class="card-title">
                            <span
                                class="element-name"
                                data-test-id="learning-library-paths-enrollable-card-title"
                            >
                                {{ item.name }}
                            </span>
                        </div>
                        <hr />
                        <div class="card-body element-description">
                            <span class="color-grey"> {{ item.description }} </span>
                        </div>
                        <div>
                            <button
                                class="btn btn-primary btn-enrol"
                                data-test-id="learning-library-paths-enroll-btn"
                                @click="enrol(item.commonId)"
                            >
                                {{ $t("learning.library.paths.enrol") }}
                            </button>
                        </div>
                    </div>
                </div>
            </template>
        </l-grid>

        <div v-if="!selfenrolList.length">
            <l-no-data
                :text="$t(`learning.library.paths.empty`)"
                :btn-show="true"
                :btn-text="$t(`learning.library.exploreTodo`)"
                :btn-handler="() => $router.push('/learning/progress')"
            />
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LHeadline from "@/components/LHeadline";
import LGrid from "@/components/LGrid";
import LNoData from "@/components/LNoData";

export default {
    components: {
        LHeadline,
        LGrid,
        LNoData,
    },
    computed: {
        ...mapGetters({
            rights: "users/current/rights",
            selfenrolList: "learning/library/selfenrolList",
        }),
        tabs() {
            return [
                {
                    label: this.$t("learning.library.tabs.learningPaths"),
                    path: "/learning/library",
                    show: this.rights.L_VIEW,
                    active: true,
                    testId: "library-paths-tab",
                },
                {
                    label: this.$t("learning.library.tabs.archive"),
                    subtitle: this.$t(`learning.library.archive.subTitle`),
                    path: "/learning/library/archive",
                    show: this.rights.L_VIEW,
                    active: false,
                    testId: "library-archive-tab",
                },
            ];
        },
    },
    methods: {
        async enrol(pathCommonId) {
            const progress = await this.$store.dispatch({
                type: "learning/progress/selfenrol",
                payload: { pathCommonId },
            });
            this.$router.push(
                `/learning/progress/${progress._id}/${progress.progressSteps[0]._id}`,
            );
        },
    },
};
</script>

<style scoped>
.card {
    cursor: default;
}
.element-description {
    max-height: 210px;
    overflow: hidden;
}
</style>
